import type { KonfigWebPush } from "@/modules/push/domain/push"
import { KUNCI_SIMPANAN_PUSH } from "@/modules/push/domain/push"

const JALUR_PEKERJA = "/firebase-messaging-sw.js"

export function dukunganPush(): boolean {
  return typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window
}

export function bacaTokenLokal(): string | null {
  try {
    return localStorage.getItem(KUNCI_SIMPANAN_PUSH)
  } catch {
    return null
  }
}

export function simpanTokenLokal(token: string | null): void {
  try {
    if (token) localStorage.setItem(KUNCI_SIMPANAN_PUSH, token)
    else localStorage.removeItem(KUNCI_SIMPANAN_PUSH)
  } catch {}
}

async function siapkanPesan(konfig: KonfigWebPush) {
  const [{ getApp, getApps, initializeApp }, { getMessaging, isSupported }] = await Promise.all([import("firebase/app"), import("firebase/messaging")])
  if (!(await isSupported())) return null
  const app = getApps().length > 0 ? getApp() : initializeApp({ apiKey: konfig.apiKey, authDomain: konfig.authDomain, projectId: konfig.projectId, messagingSenderId: konfig.messagingSenderId, appId: konfig.appId })
  return getMessaging(app)
}

export async function ambilTokenPerangkat(konfig: KonfigWebPush): Promise<string | null> {
  const pesan = await siapkanPesan(konfig)
  if (!pesan) return null
  const { getToken } = await import("firebase/messaging")
  const pendaftaran = await navigator.serviceWorker.register(JALUR_PEKERJA)
  await navigator.serviceWorker.ready
  const token = await getToken(pesan, { vapidKey: konfig.vapidKey, serviceWorkerRegistration: pendaftaran })
  return token || null
}

export async function hapusTokenPerangkat(konfig: KonfigWebPush): Promise<void> {
  const pesan = await siapkanPesan(konfig)
  if (!pesan) return
  const { deleteToken } = await import("firebase/messaging")
  await deleteToken(pesan).catch(() => false)
}

export async function dengarkanLatarDepan(konfig: KonfigWebPush, saatMasuk: (judul: string, isi: string) => void): Promise<() => void> {
  const pesan = await siapkanPesan(konfig)
  if (!pesan) return () => undefined
  const { onMessage } = await import("firebase/messaging")
  return onMessage(pesan, (muatan) => saatMasuk(muatan.notification?.title ?? "Notifikasi baru", muatan.notification?.body ?? ""))
}
